module.exports = __webpack_public_path__ + "static/media/03B.8def7d08.png";